import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface ITeamMeetingConfigShortcutMutationOptions {
	onSuccess?: (data: Api.ITeamMeetingShortcut) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * Creates a booking shortcut URL for a team meeting config
 */
export function useTeamMeetingConfigShortcutMutation(options: ITeamMeetingConfigShortcutMutationOptions = {}) {
	const { onSuccess, onError } = options;
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (id: string) => {
			return userSession.webServiceHelper.callAsync<Api.ITeamMeetingShortcut>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `TeamMeetingConfig/${id}/shortcut`,
				}),
				'POST'
			);
		},
		onSuccess,
		onError,
	});
}
